import { useParams, useNavigate } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import EditUpsellForm from "../../components/upsell/EditUpsellForm";

export default function EditUpsell() {
    const { productId, upsellId } = useParams<{ productId: string; upsellId: string }>();
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/products/edit/${productId}?tab=upsell`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Editar Upsell"
                description="Editar upsell para o produto"
            />
            <PageBreadcrumb
                pageTitle="Editar Upsell"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <EditUpsellForm
                    productId={productId}
                    upsellId={upsellId}
                    onSuccess={() => {
                        // Redirecionar para a página de edição do produto na aba de upsells
                        navigate(`/products/edit/${productId}?tab=upsell`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao editar upsell:", error);
                    }}
                />
            </div>
        </>
    );
}